<ycn-modal-base
    [open]="modalOpen"
    (closeModalHandler)="closeModal()">
    <ycn-simple-modal-header
        (closeModalHandler)="closeModal()">
    </ycn-simple-modal-header>
    <div class="modal-body">
        <div class="modal-section" *ngIf="showLimitReached">
            <p> We appreciate your enthusiastic support, however, we have a
                limit on referral submissions. We’ll review your submissions and get back to you soon.
                In the meantime, please contact us with any questions. </p>
        </div>
        <div class="modal-section" *ngIf="showCompletionModal">
            <div class="mb-2 form-title text-blue">Thank you for referring colleagues to YCharts</div>
            <p>We’ll email them some information on how to get started.</p>
        </div>
        <div class="modal-section border-b border-color-gray-80" *ngIf="!showCompletionModal && !showLimitReached">
            <div class="mb-4">
                <div class="form-title mb-4">Unlock Additional Benefits When You Refer Colleagues</div>
                <div class="row">
                    <div class="col-4">
                        <div class="benefit">
                            <svg ycnIcon [name]="'icon-benefit-1-color'" class="icon-benefit-1-color benefit-icon" role="img"></svg>
                            <div class="benefit-text">Share model strategies, proposals and more</div>
                        </div>
                    </div>
                    <div class="col-4">
                        <div class="benefit">
                            <svg ycnIcon [name]="'icon-benefit-2-color'" class="icon-benefit-2-color benefit-icon" role="img"></svg>
                            <div class="benefit-text">Create consistent branding across teams</div>
                        </div>
                    </div>
                    <div class="col-4">
                        <div class="benefit">
                            <svg ycnIcon [name]="'icon-benefit-3-color'" class="icon-benefit-3-color benefit-icon" role="img"></svg>
                            <div class="benefit-text">Save time on administrative tasks</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="mb-2">Enter an email address to invite people to YCharts.</div>
            <div class="mb-2">
                <div class="queue">
                    <div class="btn queue-item"*ngFor="let email of emails; let i = index" [ngClass]="{'btn-danger': !email.isValid }" >
                        <span>{{ email.value }}</span>
                        <div class="btn btn-xs btn-circle btn-transparent btn-close" (click)="removeEmail(i)">
                            <svg ycnIcon [name]="'icon-close'" role="img"></svg>
                        </div>
                    </div>
                    <input *ngIf="showAddEmail" class="queue-input ng-pristine ng-untouched ng-valid ng-empty" type="text" [(ngModel)]="emailInput" (blur)="onInputBlur()" (keydown)="onInputKeyDown($event)">
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <div class="modal-footer-actions">
            <div class="btn btn-text" (click)="closeModal()"
                *ngIf="!showCompletionModal && !showLimitReached">
                Cancel
            </div>
            <a class="btn btn-primary"
                href="javascript:void(0)"
                role="button"
                ycnDisabled [disabled]="processingRequest || emails.length === 0 || !this.allEmailsValid"
                *ngIf="!showCompletionModal && !showLimitReached"
                (click)="processingRequest || emails.length === 0 || !this.allEmailsValid || submitReferral()">
                Invite
            </a>
            <div class="btn btn-primary" (click)="closeModal()"
                *ngIf="showCompletionModal || showLimitReached">
                Close
            </div>
        </div>
    </div>
</ycn-modal-base>
